module.exports = __webpack_public_path__ + "img/62ne.2238ef10.svg";